// @ts-check
import { LBButton } from '@linearb/buzz';
import { Tooltip } from '@material-ui/core';

const IssuesButton = ({ onClick, disabled }) => {
  return (
    <div className='ml-auto mr-1'>
      <Tooltip
        title='There are no issues for this category'
        disableHoverListener={!disabled}
      >
        <span>
          <LBButton variant='outline' onClick={onClick} disabled={disabled}>
            View Issues
          </LBButton>
        </span>
      </Tooltip>
    </div>
  );
};

export default IssuesButton;
